import React from "react";

const CustomerDetailScreen = () => {
  return <div>CustomerDetailScreen</div>;
};

export default CustomerDetailScreen;
